import { useState, useEffect, useLayoutEffect, useRef, useCallback } from "react";
import vsolai from "./assets/vsolai.png";
import vsolai1 from "./assets/vsolai1.png";
import vsolai3 from "./assets/vsolai3.png";
import wheat from "./assets/icons/wheat.png";
import wheat1 from "./assets/icons/wheat1.png";
import products from "./assets/icons/products.png";
import Bayer from "./assets/Bayer.jpg";
import bayer1 from "./assets/bayer1.png";
import synn from "./assets/synn.png";
import upl from "./assets/upl.png";
import inf from "./assets/inf.png";
import cor from "./assets/cor.png";
import adma from "./assets/adma.png";
import cort from "./assets/cort.png";
import pi from "./assets/pi.png";
import fertilizer from "./assets/icons/fertilizer.png";
import sprout from "./assets/icons/sprout.png";
import crop from "./assets/icons/crop.png";
import equi from "./assets/icons/equi.png";
import farmer from "./assets/icons/farmer.png";
import fb from "./assets/icons/fb.png";
import insta from "./assets/icons/insta.png";
import you from "./assets/icons/you.png";
import wa from "./assets/icons/wa.png";
import pady from "./assets/pady.png";
import weed from "./assets/weed.png";
import toma from "./assets/toma.png";
import pion from "./assets/pion.png";
import bhen from "./assets/bhen.png";
import npk from "./assets/npk.png";
import cal from "./assets/cal.png";
import organic from "./assets/organic.png";
import npk20 from "./assets/npk20.png";
import dap from "./assets/dap.png";
import ureaa from "./assets/ureaa.png";
import medo from "./assets/medo.png";
import imi from "./assets/imi.png";
import sprint from "./assets/sprint.png";
import avatar from "./assets/avatar.png";
import sumi from "./assets/sumi.png";
import lattu from "./assets/lattu.png";
import vamos from "./assets/vamos.png";
import rice from "./assets/rice.png";
import eros from "./assets/eros.png";
import erase from "./assets/erase.png";
import kris from "./assets/kris.png";
import krti from "./assets/krti.png";
import amit from "./assets/ambit.png";
import lent from "./assets/lent.png";
import nami from "./assets/nami.png";
import kissan from "./assets/kissan.png";
import winner from "./assets/winner.png";
import win from "./assets/win.png";
import indo from "./assets/indo.png";
import naga from "./assets/naga.png";
import centran from "./assets/centran.png";
import saathi from "./assets/saathi.png";
import indofil from "./assets/indofil.png";
import sumii from "./assets/sumii.png";
import techno from "./assets/techno.png";
import battery from "./assets/battery.png";
import knap from "./assets/knap.png";
import slide1 from "./assets/slide1.jpg";
import slide2 from "./assets/slide2.jpg";
import slide3 from "./assets/slide3.jpg";
/* ══════════════════════════════════════════════════════════
   📷  IMAGES — drop real photos into src/assets/ and import
   them here, then swap the matching placeholder URL below
   (in SLIDES / PRODUCTS / BLOG_POSTS) for the imported name.

   Example, once you add files to src/assets/:

     import slideSeeds       from "./assets/slides/seeds.jpg";
     import slideFertilizer  from "./assets/slides/fertilizer.jpg";
     import slideProtection  from "./assets/slides/protection.jpg";
     import slideAdvisory    from "./assets/slides/advisory.jpg";

     import imgPaddySeed     from "./assets/products/paddy-bpt5204.jpg";
     import imgNpkFert       from "./assets/products/npk-19-19-19.jpg";
     import imgFungicide     from "./assets/products/medose-fungicide.jpg";
     ...and so on for every product/blog image you need.

   Then in the SLIDES / PRODUCTS / BLOG_POSTS arrays further
   down, change:   image: "https://picsum.photos/..."
   to:             image: slideSeeds   (no quotes — it's a variable)

   Until you add real photos, the placeholder URLs below keep
   everything working so the layout can be previewed as-is.
   ══════════════════════════════════════════════════════════ */

/* ══════════════════════════════════════════════════════════
   🔖  ICONS — every icon slot on this site (categories, brand
   logos, contact/advisory icons, footer social icons, etc.)
   is rendered through the <IconBox> component below. It accepts
   EITHER an emoji/text string (used today) OR an imported image
   file — so swapping a placeholder emoji for a real icon/logo
   image later is a one-line change, no markup edits needed.

   To add a real icon image later:
     import iconSeeds from "./assets/icons/seeds.svg";
     ...then in the relevant data array, change:
       icon: "🌾"        →    icon: iconSeeds
   <IconBox> auto-detects image paths vs. emoji/text and renders
   the right thing automatically.
   ══════════════════════════════════════════════════════════ */

/* Belt-and-suspenders fix for the "gap above header" issue:
   runs the instant this module is evaluated (before React's
   first render), zeroing out the browser's default body/html
   margin so there's never a flash of un-reset spacing above
   the sticky navbar — GLOBAL_CSS below reinforces this with a
   stylesheet rule once the component mounts. */
if (typeof document !== "undefined") {
  document.documentElement.style.cssText = "margin:0!important;padding:0!important;";
  if (document.body) {
    document.body.style.cssText = "margin:0!important;padding:0!important;";
  }
  // inject a <style> tag immediately so there's zero flash before useLayoutEffect
  const earlyStyle = document.createElement("style");
  earlyStyle.textContent = "html,body,#root,header,main{margin:0!important;padding:0!important;}";
  (document.head||document.documentElement).appendChild(earlyStyle);
}

/* ── TOKENS ── */
const T = {
  forest:"#5B340D", emerald:"#A35D17", leaf:"#DD7E1F",
  mint:"#F4EBE1", gold:"#D97706", goldLight:"#F2E9DC",
  cream:"#FAFAF7", charcoal:"#1F1A16", slate:"#4B5563",
  muted:"#9CA3AF", border:"#E8DCC8", danger:"#DC2626", info:"#0369A1",
};
const G = {
  hero:`linear-gradient(135deg,${T.forest} 0%,${T.emerald} 55%,${T.leaf} 100%)`,
  gold:`linear-gradient(135deg,${T.goldLight} 0%,#F5F0E8 100%)`,
  leaf:`linear-gradient(135deg,${T.emerald} 0%,${T.leaf} 100%)`,
  card:`linear-gradient(160deg,#fff 0%,${T.mint} 100%)`,
};

// 📲 WhatsApp Business number for V-Solai — replace with your real number
// (country code + number, no +, no spaces, no dashes). e.g. India 98765 43210 → "919876543210"
const WHATSAPP_NUMBER = "919876543210";
function sendWhatsApp(message) {
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
}

/* ── GLOBAL STYLES ── */
const GLOBAL_CSS = `
@import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,500;9..144,600;9..144,700;9..144,800&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

*{box-sizing:border-box;margin:0;padding:0;}
html,body,#root{margin:0!important;padding:0!important;min-height:100%;}
html{scroll-behavior:smooth;margin-top:0!important;}
body{font-family:'Inter','Segoe UI',system-ui,sans-serif;background:#FAFAF7;overflow-x:hidden;margin-top:0!important;padding-top:0!important;}
#root{display:flex;flex-direction:column;margin-top:0!important;padding-top:0!important;}
header,main,footer,nav,section,article{display:block;margin:0!important;padding:0;}
input,select,textarea,button{font-family:inherit;}

/* ── ICON BOX (used by every icon slot site-wide) ── */
.icon-box{display:flex;align-items:center;justify-content:center;flex-shrink:0;overflow:hidden;}
.icon-box img{width:100%;height:100%;object-fit:contain;display:block;}

/* ── BRAND LOGO CARDS ── */
.retailer-card{display:flex;align-items:center;justify-content:center;background:transparent;border-radius:8px;padding:10px;min-height:96px;transition:all 0.22s;}
.retailer-card:hover{transform:translateY(-3px);}
.retailer-card img{max-width:100%;max-height:64px;object-fit:contain;}
.retailer-wordmark{font-weight:800;font-size:19px;letter-spacing:-0.3px;text-align:center;line-height:1.25;}

/* ── FOOTER TYPOGRAPHY (premium pairing: Fraunces display + Plus Jakarta Sans body) ── */
.footer-wordmark{font-family:'Fraunces',Georgia,serif;font-weight:700;font-style:italic;letter-spacing:0.2px;}
.footer-desc{font-family:'Plus Jakarta Sans','Inter',sans-serif;font-weight:400;}
.footer-heading{font-family:'Plus Jakarta Sans','Inter',sans-serif;font-weight:700;font-style:normal;}
.footer-link{font-family:'Plus Jakarta Sans','Inter',sans-serif;font-weight:500;}
.footer-contact-line{font-family:'Plus Jakarta Sans','Inter',sans-serif;font-weight:500;}
.footer-bottom-text{font-family:'Plus Jakarta Sans','Inter',sans-serif;font-weight:500;}
.footer-social-btn{font-family:'Plus Jakarta Sans','Inter',sans-serif;}

/* ── FOOTER LINK LISTS — collapses to a compact 2-col grid on mobile ── */
.footer-links-list{display:flex;flex-direction:column;gap:9px;}

@keyframes fadeSlide{from{opacity:0;transform:translateX(40px)}to{opacity:1;transform:translateX(0)}}
@keyframes fadeUp{from{opacity:0;transform:translateY(28px)}to{opacity:1;transform:translateY(0)}}
@keyframes dotPulse{0%,100%{transform:scale(1)}50%{transform:scale(1.3)}}
@keyframes mobileMenu{from{opacity:0;transform:translateY(-8px)}to{opacity:1;transform:translateY(0)}}
@keyframes progressBar{from{width:0}to{width:100%}}
@keyframes shimmer{0%{background-position:-400px 0}100%{background-position:400px 0}}
@keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-12px)}}
@keyframes scaleIn{from{opacity:0;transform:scale(0.92)}to{opacity:1;transform:scale(1)}}

/* ── HERO SLIDER ── */
.hero-slider{position:relative;overflow:hidden;min-height:100vh;display:flex;flex-direction:column;background:#000;}
.hero-bg{position:absolute;inset:0;}
.hero-overlay{position:absolute;inset:0;background:linear-gradient(180deg,rgba(0,0,0,0.18) 0%,transparent 40%,rgba(0,0,0,0.25) 100%);}
.hero-content{position:relative;z-index:2;flex:1;display:flex;align-items:center;padding:100px 28px 80px;}
.hero-inner{max-width:1320px;margin:0 auto;width:100%;display:grid;grid-template-columns:1fr 1fr;gap:60px;align-items:center;}
.hero-text{color:#fff;}
.hero-eyebrow{display:inline-flex;align-items:center;gap:8px;background:rgba(255,255,255,0.13);border:1px solid rgba(255,255,255,0.22);border-radius:24px;padding:6px 16px;font-size:11px;font-weight:700;letter-spacing:1.2px;text-transform:uppercase;margin-bottom:24px;}
.hero-h1{font-size:54px;font-weight:900;line-height:1.06;letter-spacing:-1.5px;margin:0 0 20px;white-space:pre-line;}
.hero-sub{font-size:16px;color:rgba(255,255,255,0.74);line-height:1.8;max-width:460px;margin-bottom:36px;}
.hero-btns{display:flex;gap:14px;flex-wrap:wrap;margin-bottom:36px;}
.hero-btn-primary{background:linear-gradient(135deg,#F2E9DC,#FFFFFF);color:#000000;border:none;border-radius:12px;padding:15px 32px;font-size:15px;font-weight:800;cursor:pointer;box-shadow:0 8px 24px rgba(0,0,0,0.35);transition:all 0.2s;letter-spacing:-0.2px;}
.hero-btn-primary:hover{transform:translateY(-2px);box-shadow:0 12px 32px rgba(0,0,0,0.45);}
.hero-btn-secondary{background:rgba(255,255,255,0.1);color:#fff;border:1.5px solid rgba(255,255,255,0.35);border-radius:12px;padding:15px 26px;font-size:14px;font-weight:600;cursor:pointer;backdrop-filter:blur(4px);transition:all 0.2s;}
.hero-btn-secondary:hover{background:rgba(255,255,255,0.18);}
.hero-stat-badge{display:inline-flex;align-items:center;gap:10px;background:rgba(255,255,255,0.1);border:1px solid rgba(255,255,255,0.18);border-radius:10px;padding:10px 16px;backdrop-filter:blur(6px);}
.hero-visual{display:grid;grid-template-columns:1fr 1fr;gap:16px;}
.hero-card{background:rgba(255,255,255,0.1);border:1px solid rgba(255,255,255,0.18);border-radius:18px;padding:24px 20px;backdrop-filter:blur(8px);transition:all 0.3s;}
.hero-card:hover{background:rgba(255,255,255,0.16);transform:translateY(-4px);}
.hero-card-num{font-size:28px;font-weight:900;margin:12px 0 6px;}
.hero-card-label{font-size:12px;color:rgba(255,255,255,0.65);}
.hero-nav-row{position:relative;z-index:3;display:flex;align-items:center;justify-content:center;gap:20px;padding-bottom:28px;}
.hero-dot-btn{width:10px;height:10px;border-radius:5px;border:none;cursor:pointer;transition:all 0.3s;padding:0;}
.hero-arrow{background:rgba(255,255,255,0.15);border:1.5px solid rgba(255,255,255,0.25);color:#fff;width:38px;height:38px;border-radius:50%;cursor:pointer;font-size:16px;display:flex;align-items:center;justify-content:center;transition:all 0.2s;}
.hero-arrow:hover{background:rgba(255,255,255,0.28);}
.hero-progress{position:absolute;bottom:0;left:0;right:0;height:3px;background:rgba(255,255,255,0.1);}

/* ── ADVISORY HERO SLIDER ── */
.advisory-hero-slider{position:relative;overflow:hidden;height:380px;}
.advisory-slide-bg{position:absolute;inset:0;transition:background 0.9s ease;}

/* ── NAVBAR (premium, centered menu) ── */
.navbar-topline{height:3px;background:linear-gradient(90deg,${T.forest} 0%,${T.leaf} 50%,${T.forest} 100%);}
.navbar-wrap{background:rgba(255,255,255,0.86);backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);position:sticky;top:0;z-index:300;transition:background 0.35s ease,box-shadow 0.35s ease,border-color 0.35s ease;border-bottom:2px solid ${T.leaf};margin-top:0!important;}
.navbar-wrap.scrolled{background:rgba(74,34,8,0.97);box-shadow:0 8px 28px rgba(0,0,0,0.28);border-bottom-color:rgba(255,255,255,0.1);}
.navbar-row{display:grid;grid-template-columns:1fr auto 1fr;align-items:center;max-width:1320px;margin:0 auto;padding:0 20px;height:72px;gap:16px;}
.nav-links-center{display:flex;justify-self:center;}
.nav-actions{display:flex;align-items:center;gap:12px;justify-self:end;}
.nav-link-btn{position:relative;background:none;border:none;padding:9px 16px;font-size:13px;cursor:pointer;border-radius:24px;transition:all 0.18s;letter-spacing:0.1px;}
.nav-link-btn.active{background:${T.mint};}
.navbar-wrap.scrolled .nav-link-btn.active{background:rgba(255,255,255,0.18);}
.nav-link-btn:not(.active):hover{background:rgba(163,93,23,0.08);}
.navbar-wrap.scrolled .nav-link-btn:not(.active):hover{background:rgba(255,255,255,0.12);}

/* ── RESPONSIVE ── */
@media(max-width:900px){
  .hero-inner{grid-template-columns:1fr!important;}
  .hero-visual{display:none!important;}
  .hero-h1{font-size:38px!important;letter-spacing:-0.8px!important;}
  .hero-content{padding:90px 20px 60px!important;}
}
@media(max-width:768px){
  .hero-slider{min-height:auto!important;}
  .hero-content{padding:80px 16px 50px!important;}
  .hero-h1{font-size:30px!important;letter-spacing:-0.5px!important;}
  .hero-sub{font-size:14px!important;}
  .hero-btns{flex-direction:column!important;gap:10px!important;}
  .hero-btn-primary,.hero-btn-secondary{width:100%!important;text-align:center!important;}
  .hero-eyebrow{font-size:10px!important;}
  .section-pad{padding:40px 16px!important;}
  .section-h2{font-size:22px!important;}
  .two-col{grid-template-columns:1fr!important;}
  .three-col{grid-template-columns:1fr!important;}
  .four-col{grid-template-columns:1fr 1fr!important;}
  .prod-grid{gap:12px!important;}
  .prod-card-wrap{width:calc(50% - 6px)!important;min-width:0!important;max-width:none!important;}
  .footer-grid{grid-template-columns:1fr 1fr!important;}
  .nav-links-center{display:none!important;}
  .nav-mobile-btn{display:flex!important;}
  .navbar-row{grid-template-columns:auto 1fr auto!important;height:64px!important;}
  .cart-drawer{width:100vw!important;}
  .advisory-layout{grid-template-columns:1fr!important;}
  .contact-layout{grid-template-columns:1fr!important;}
  .advisory-hero-slider{height:260px!important;}
  .advisory-hero-h1{font-size:24px!important;}
  .advisory-hero-p{font-size:13px!important;}
  .brands-grid{gap:10px!important;}
  .retailer-card{padding:8px!important;min-height:70px!important;}
  .retailer-card img{max-height:44px!important;}
  .page-hero-h1{font-size:26px!important;}
  .seasonal-grid{grid-template-columns:1fr!important;}
  .seasonal-mini{grid-template-columns:1fr 1fr!important;}
  /* Compact two-column link lists for Products / Quick Links in mobile footer */
  .footer-links-list{display:grid!important;grid-template-columns:1fr 1fr!important;gap:8px 16px!important;}
  .footer-social-row{justify-content:flex-start!important;}
}
@media(max-width:480px){
  .prod-card-wrap{width:100%!important;max-width:none!important;}
  .four-col{grid-template-columns:1fr!important;}
  .footer-grid{grid-template-columns:1fr!important;}
  .hero-h1{font-size:26px!important;}
  .hero-nav-row{gap:12px!important;}
  .advisory-hero-slider{height:220px!important;}
  .advisory-hero-h1{font-size:20px!important;}
  .brands-grid{grid-template-columns:repeat(3,1fr)!important;}
}
`;

/* ── DATA ── */
const SLIDES = [
  {
    eyebrow:"Premium Seeds Collection",
    title:"Maximum Yield\nStarts with the\nRight Seed",
    sub:"Certified hybrid seeds for paddy, vegetables & field crops. Trusted by 5,000+ Tamil Nadu farmers.",
    cta:"Shop Seeds", ctaPage:"seeds",
    accent:T.goldLight, bg:"linear-gradient(135deg,rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.5) 100%)",
    bgImage: slide1,    // ← Hero background image (line 296)
    slideImage: slide1, // ← Right side panel image (line 297)
    icon: farmer, stat:"40% more yield guaranteed",
  },
  {
    eyebrow:"Fertilizer Range",
    title:"Balanced Nutrition\nfor Every Crop\n& Every Stage",
    sub:"NPK, micronutrients, and bio-stimulants from IFFCO, Coromandel & more. Lab-tested, farmer-proven.",
    cta:"Shop Fertilizers", ctaPage:"fertilizers",
    accent:T.goldLight, bg:"linear-gradient(135deg,rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.5) 100%)",
    bgImage: slide2,    // ← Hero background image (line 305)
    slideImage: slide2, // ← Right side panel image (line 306)
    icon:products, stat:"200+ fertilizer products",
  },
  {
    eyebrow:"Crop Protection",
    title:"Protect Your\nHarvest from\nPests & Disease",
    sub:"Certified insecticides, fungicides & herbicides from Bayer, Syngenta & UPL. 100% genuine products.",
    cta:"Shop Protection", ctaPage:"crop-protection",
    accent:T.goldLight, bg:"linear-gradient(135deg,rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.5) 100%)",
    bgImage: slide3,    // ← Hero background image (line 314)
    slideImage: slide3, // ← Right side panel image (line 315)
    icon:"🛡️", stat:"Zero counterfeit guarantee",
  },
];



const PRODUCTS = [
  {id:1,name:"Paddy Hybrid BPT 5204",cat:"seeds",price:25,mrp:32,unit:"500g",badge:"Bestseller",rating:4.8,rev:124,image:pady,icon:"fa-seedling",desc:"High-yield hybrid paddy. Disease-resistant, early maturity. Suited for delta regions."},
  {id:2,name:"NPK 19:19:19 Fertilizer",cat:"fertilizers",price:35,mrp:42,unit:"1kg",badge:"New",rating:4.6,rev:87,image:npk,icon:"fa-flask",desc:"Balanced water-soluble NPK for foliar and drip irrigation use."},
  {id:3,name:"Medose Fungicide",cat:"protection",price:25,mrp:30,unit:"250ml",badge:null,rating:4.5,rev:63,image:medo,icon:"fa-pills",desc:"Broad-spectrum systemic fungicide for blast, blight, and wilt."},
  {id:4,name:"WeedClear Pro Herbicide",cat:"protection",price:16,mrp:20,unit:"500ml",badge:"Hot",rating:4.7,rev:201,image:weed,icon:"fa-leaf",desc:"Selective herbicide for paddy & wheat. Controls grassy and broadleaf weeds."},
  {id:5,name:"Tomato Hybrid F1 Seeds",cat:"seeds",price:45,mrp:55,unit:"10g",badge:"Premium",rating:4.9,rev:56,image:toma,icon:"fa-seedling",desc:"High-brix tomato hybrid. Excellent shelf life for protected cultivation."},
  {id:6,name:"Calcium Boron Micronutrient",cat:"fertilizers",price:28,mrp:35,unit:"500g",badge:null,rating:4.4,rev:42,image:cal,icon:"fa-flask",desc:"Chelated Ca-B prevents blossom-end rot and improves fruit quality."},
  {id:7,name:"Bhendi Hybrid Seeds",cat:"seeds",price:18,mrp:22,unit:"50g",badge:null,rating:4.3,rev:38,image:bhen,icon:"fa-seedling",desc:"High-yielding bhendi hybrid. Tolerant to yellow vein mosaic virus."},
  {id:8,name:"Battery Operated Sprayer",cat:"equipment",price:1850,mrp:2200,unit:"1 unit",badge:"Popular",rating:4.7,rev:95,image:battery,icon:"fa-gears",desc:"16L, 3-gear motor, adjustable nozzle for fine mist and stream modes."},
  {id:9,name:"Maize Hybrid Pioneer 30V92",cat:"seeds",price:320,mrp:380,unit:"1 unit",badge:"Premium",rating:4.8,rev:73,image:pion,icon:"fa-wheat-awn",desc:"Stay-green maize hybrid. High starch content, excellent standability."},
  {id:10,name:"Imidacloprid 17.8 SL",cat:"protection",price:120,mrp:145,unit:"100ml",badge:null,rating:4.5,rev:55,image:imi,icon:"fa-microscope",desc:"Systemic insecticide for aphids, thrips, and whiteflies."},
  {id:11,name:"Organic Bio-Stimulant",cat:"fertilizers",price:75,mrp:90,unit:"500ml",badge:"Organic",rating:4.6,rev:48,image:organic,icon:"fa-seedling",desc:"Seaweed-based bio-stimulant. Improves root growth and stress tolerance."},
  {id:12,name:"Knapsack Manual Sprayer",cat:"equipment",price:650,mrp:800,unit:"1 unit",badge:null,rating:4.3,rev:62,image:knap,icon:"fa-bag-shopping",desc:"16L corrosion-resistant tank. Padded straps for long-duration use."},

  // ── Client-supplied catalog (from physical order book) ──
  // ⚠️ price / mrp / unit below are PLACEHOLDERS — update with real values before going live.
  {id:13,name:"SOP 0:0:50 (Sulphate of Potash)",cat:"fertilizers",price:180,mrp:210,unit:"1kg",badge:null,rating:4.5,rev:21,image:pady,icon:"fa-flask",desc:"Water-soluble Sulphate of Potash (0:0:50). Improves fruit quality, disease tolerance & shelf life."},
  {id:14,name:"NPK 20:20:0:13",cat:"fertilizers",price:190,mrp:220,unit:"1kg",badge:null,rating:4.4,rev:17,image:npk20,icon:"fa-flask",desc:"Balanced NPK 20:20:0:13 grade with sulphur, suited for field & horticulture crops."},
  {id:15,name:"DAP (Di-Ammonium Phosphate)",cat:"fertilizers",price:1450,mrp:1550,unit:"50kg Bag",badge:"Bestseller",rating:4.6,rev:54,image:dap,icon:"fa-flask",desc:"Strong starter fertilizer for root development at the sowing stage."},
  {id:16,name:"Urea (46% Nitrogen)",cat:"fertilizers",price:350,mrp:380,unit:"45kg Bag",badge:"Bestseller",rating:4.5,rev:68,image:ureaa,icon:"fa-flask",desc:"Standard granular top-dressing fertilizer for vegetative growth."},
  {id:17,name:"Sprint",cat:"protection",price:200,mrp:235,unit:"250g",badge:null,rating:4.2,rev:12,image:sprint,icon:"fa-shield",desc:"Trusted crop protection product for field & horticulture crops. Ask our experts for the right dosage & timing."},
  {id:18,name:"Avatar",cat:"protection",price:215,mrp:253,unit:"500ml",badge:"Bestseller",rating:4.3,rev:19,image:avatar,icon:"fa-shield",desc:"Quality crop protection input stocked at V-Solai. Talk to our agronomists for crop-specific application advice."},
  {id:19,name:"Sumi Gold",cat:"protection",price:230,mrp:271,unit:"500ml",badge:null,rating:4.4,rev:26,image:sumi,icon:"fa-shield",desc:"Genuine branded crop protection solution. Our team can recommend the correct dosage for your crop & pest issue."},
  {id:20,name:"Laattu",cat:"protection",price:245,mrp:289,unit:"250g",badge:null,rating:4.5,rev:33,image:lattu,icon:"fa-shield",desc:"Reliable crop protection product from our catalog. Contact our advisory team for usage guidelines."},
  {id:21,name:"Sumi Blue Diamond",cat:"protection",price:260,mrp:307,unit:"500ml",badge:null,rating:4.6,rev:40,image:sumii,icon:"fa-shield",desc:"Trusted crop protection product for field & horticulture crops. Ask our experts for the right dosage & timing."},
  {id:22,name:"Tecno",cat:"protection",price:275,mrp:325,unit:"500ml",badge:"New",rating:4.2,rev:47,image:techno,icon:"fa-shield",desc:"Quality crop protection input stocked at V-Solai. Talk to our agronomists for crop-specific application advice."},
  {id:23,name:"Vamos",cat:"protection",price:200,mrp:235,unit:"250g",badge:null,rating:4.3,rev:54,image:vamos,icon:"fa-shield",desc:"Genuine branded crop protection solution. Our team can recommend the correct dosage for your crop & pest issue."},
  {id:24,name:"Rice Act",cat:"protection",price:215,mrp:253,unit:"500ml",badge:"Bestseller",rating:4.4,rev:61,image:rice,icon:"fa-shield",desc:"Reliable crop protection product from our catalog. Contact our advisory team for usage guidelines."},
  {id:25,name:"Eros",cat:"protection",price:230,mrp:271,unit:"500ml",badge:null,rating:4.5,rev:68,image:eros,icon:"fa-shield",desc:"Trusted crop protection product for field & horticulture crops. Ask our experts for the right dosage & timing."},
  {id:26,name:"Eraze Strong",cat:"protection",price:245,mrp:289,unit:"250g",badge:null,rating:4.6,rev:75,image:erase,icon:"fa-shield",desc:"Quality crop protection input stocked at V-Solai. Talk to our agronomists for crop-specific application advice."},
  {id:27,name:"Krizisha",cat:"protection",price:260,mrp:307,unit:"500ml",badge:null,rating:4.2,rev:12,image:kris,icon:"fa-shield",desc:"Genuine branded crop protection solution. Our team can recommend the correct dosage for your crop & pest issue."},
  {id:28,name:"Kritap SP",cat:"protection",price:275,mrp:325,unit:"500ml",badge:null,rating:4.3,rev:19,image:krti,icon:"fa-shield",desc:"Reliable crop protection product from our catalog. Contact our advisory team for usage guidelines."},
  {id:29,name:"Ambit",cat:"protection",price:200,mrp:235,unit:"250g",badge:null,rating:4.4,rev:26,image:amit,icon:"fa-shield",desc:"Trusted crop protection product for field & horticulture crops. Ask our experts for the right dosage & timing."},
  {id:30,name:"Lentigo",cat:"protection",price:215,mrp:253,unit:"500ml",badge:"Bestseller",rating:4.5,rev:33,image:lent,icon:"fa-shield",desc:"Quality crop protection input stocked at V-Solai. Talk to our agronomists for crop-specific application advice."},
  {id:31,name:"Nami",cat:"protection",price:230,mrp:271,unit:"500ml",badge:null,rating:4.6,rev:40,image:nami,icon:"fa-shield",desc:"Genuine branded crop protection solution. Our team can recommend the correct dosage for your crop & pest issue."},
  {id:32,name:"Kissan Super",cat:"protection",price:245,mrp:289,unit:"250g",badge:null,rating:4.2,rev:47,image:kissan,icon:"fa-shield",desc:"Reliable crop protection product from our catalog. Contact our advisory team for usage guidelines."},
  {id:33,name:"Winner 3G",cat:"protection",price:260,mrp:307,unit:"500ml",badge:"New",rating:4.3,rev:54,image:winner,icon:"fa-shield",desc:"Trusted crop protection product for field & horticulture crops. Ask our experts for the right dosage & timing."},
  {id:34,name:"Wingil",cat:"protection",price:275,mrp:325,unit:"500ml",badge:null,rating:4.4,rev:61,image:win,icon:"fa-shield",desc:"Quality crop protection input stocked at V-Solai. Talk to our agronomists for crop-specific application advice."},
  {id:35,name:"Indofil Z-78",cat:"protection",price:200,mrp:235,unit:"250g",badge:null,rating:4.5,rev:68,image:indo,icon:"fa-shield",desc:"Genuine branded crop protection solution. Our team can recommend the correct dosage for your crop & pest issue."},
  {id:36,name:"Fertis",cat:"protection",price:215,mrp:253,unit:"500ml",badge:null,rating:4.6,rev:75,image:naga,icon:"fa-shield",desc:"Reliable crop protection product from our catalog. Contact our advisory team for usage guidelines."},
  {id:37,name:"Centran",cat:"protection",price:230,mrp:271,unit:"500ml",badge:null,rating:4.2,rev:12,image:centran,icon:"fa-shield",desc:"Trusted crop protection product for field & horticulture crops. Ask our experts for the right dosage & timing."},
  {id:38,name:"Saathi",cat:"protection",price:245,mrp:289,unit:"250g",badge:null,rating:4.3,rev:19,image:saathi,icon:"fa-shield",desc:"Quality crop protection input stocked at V-Solai. Talk to our agronomists for crop-specific application advice."},
  {id:39,name:"Indofil Mix",cat:"protection",price:260,mrp:307,unit:"500ml",badge:null,rating:4.4,rev:26,image:indofil,icon:"fa-shield",desc:"Genuine branded crop protection solution. Our team can recommend the correct dosage for your crop & pest issue."},
];

// 🖼️ Each brand supports an optional logo image. Until a logo is added,
// a colored initials badge is shown automatically (see IconBox usage below).
// To add a real logo later:  import logoBayer from "./assets/brands/bayer.png";
// ...then set:  logo: logoBayer
const BRANDS=[{name:"Bayer",color:"#01548B",logo:bayer1},{name:"Syngenta",color:"#0066A1",logo:synn},{name:"UPL",color:"#FF6B00",logo:upl},{name:"IFFCO",color:"#009E3F",logo:inf},{name:"Coromandel",color:"#C8202F",logo:cor},{name:"ADAMA",color:"#003F7D",logo:adma},{name:"Corteva",color:"#003DA5",logo:cort},{name:"PI Indust.",color:"#6B2D8B",logo:pi}];
const TESTIMONIALS=[
  {name:"Rajesh Kumar",loc:"Thanjavur, TN",text:"V-Solai seeds gave me 40% more yield this season. The paddy hybrid BPT 5204 is outstanding quality.",rating:5,crop:"Paddy Farmer"},
  {name:"Murugesan P",loc:"Madurai, TN",text:"Best agri shop in the region. Expert advice helped me control a severe blast attack effectively.",rating:5,crop:"Vegetable Farmer"},
  {name:"Lakshmi Devi",loc:"Tiruchy, TN",text:"Fast delivery and authentic products. The organic fertilizers transformed my tomato garden.",rating:4,crop:"Horticulture Farmer"},
  {name:"Selvam R",loc:"Dindigul, TN",text:"Fair price, genuine products, knowledgeable team. V-Solai is my go-to shop every season.",rating:5,crop:"Mixed Crop Farmer"},
];
const BLOG_POSTS=[
  {id:1,title:"Best Paddy Varieties for Kharif 2024",excerpt:"Choosing the right paddy variety can increase your yield by 30-40%. Expert guide for the upcoming season.",date:"Jun 10, 2024",readTime:"5 min",tag:"Seeds",icon:"🌾"},
  {id:2,title:"Integrated Pest Management for Tomato",excerpt:"Combine biological, cultural, and chemical controls to protect your tomato crop while reducing costs.",date:"Jun 3, 2024",readTime:"7 min",tag:"Crop Protection",icon:"🛡️"},
  {id:3,title:"Understanding NPK Ratios for Your Soil",excerpt:"Break down soil test results and choose the right NPK formulation for your specific field.",date:"May 28, 2024",readTime:"6 min",tag:"Fertilizers",icon:"🧪"},
];
const ADVISORS=[
  {name:"Dr. Arumugam S",title:"Chief Agronomist",exp:"18 years",spec:"Paddy & Millets",icon:""},
  {name:"Priya Rajan",title:"Horticulture Expert",exp:"12 years",spec:"Vegetables & Fruits",icon:""},
  {name:"Karthik M",title:"Soil Scientist",exp:"10 years",spec:"Soil Health & Nutrition",icon:""},
];

/* ── HERO SLIDER (Full Height) ── */
function HeroSlider({ setPage }) {
  const [cur, setCur] = useState(0);
  const [animKey, setAnimKey] = useState(0);
  const timerRef = useRef(null);

  // Preload all slide images to prevent black flash on refresh
  useEffect(() => {
    SLIDES.forEach(slide => {
      if(slide.bgImage){ const img=new Image(); img.src=slide.bgImage; }
      if(slide.slideImage){ const img=new Image(); img.src=slide.slideImage; }
    });
  }, []);

  const go = useCallback((idx) => {
    setCur(idx);
    setAnimKey(k => k + 1);
  }, []);

  const startTimer = useCallback(() => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setCur(c => { const n=(c+1)%SLIDES.length; setAnimKey(k=>k+1); return n; });
    }, 5500);
  }, []);

  useEffect(() => { startTimer(); return () => clearInterval(timerRef.current); }, [startTimer]);

  const s = SLIDES[cur];

  return (
    <section className="hero-slider">
      {s.bgImage ? (
        <div className="hero-bg" style={{
          backgroundImage:`url(${s.bgImage})`,backgroundSize:"cover",backgroundPosition:"center",
        }}/>
      ) : (
        <div className="hero-bg" style={{background:s.bg}}/>
      )}
      <div className="hero-bg" style={{background:"linear-gradient(135deg,rgba(0,0,0,0.65) 0%,rgba(0,0,0,0.4) 100%)"}}/>
      <div className="hero-overlay"/>

      {/* Decorative blobs */}
      <div style={{position:"absolute",top:-100,right:-80,width:500,height:500,borderRadius:"50%",background:"rgba(255,255,255,0.025)",pointerEvents:"none"}}/>
      <div style={{position:"absolute",bottom:-80,left:"15%",width:360,height:360,borderRadius:"50%",background:"rgba(255,255,255,0.03)",pointerEvents:"none"}}/>
      <div style={{position:"absolute",top:"30%",right:"5%",width:200,height:200,borderRadius:"50%",background:"rgba(255,255,255,0.02)",pointerEvents:"none"}}/>

      {/* Content */}
      <div className="hero-content">
        <div className="hero-inner" style={{gridTemplateColumns:"1fr 1fr"}}>
          {/* Left text */}
          <div key={animKey} className="hero-text" style={{animation:"fadeSlide 0.6s cubic-bezier(0.22,1,0.36,1) both"}}>
            <div className="hero-eyebrow" style={{color:s.accent}}>
              <IconBox icon={s.icon} box={18} size={16} bg="transparent" radius={0}/>
              {s.eyebrow}
            </div>
            <h1 className="hero-h1">{s.title}</h1>
            <p className="hero-sub">{s.sub}</p>
            <div className="hero-btns">
              <button className="hero-btn-primary" onClick={()=>setPage(s.ctaPage)}>
                {s.cta} →
              </button>
              <button className="hero-btn-secondary" onClick={()=>setPage("contact")}>
                <i className="fa-solid fa-phone" style={{color:"#fff", fontSize:"16px", verticalAlign:"middle"}}></i> Call Us Now
              </button>
            </div>
            <div className="hero-stat-badge">
              <IconBox icon={s.icon} box={22} size={20} bg="transparent" radius={0}/>
              <span style={{fontSize:13,color:s.accent,fontWeight:700}}>{s.stat}</span>
            </div>
          </div>

          {/* Right: slide image — set slideImage in SLIDES data to show a real photo */}
          <div key={`img-${animKey}`} style={{display:"flex",alignItems:"center",justifyContent:"center",animation:"scaleIn 0.7s cubic-bezier(0.22,1,0.36,1) both",animationDelay:"0.15s"}}>
            {s.slideImage ? (
              <img src={s.slideImage} alt={s.eyebrow} style={{width:"100%",height:"420px",objectFit:"cover",borderRadius:20,boxShadow:"0 20px 60px rgba(0,0,0,0.35)"}}/>
            ) : (
              <div style={{width:"100%",height:"420px",borderRadius:20,border:"2px dashed rgba(255,255,255,0.25)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:12,background:"rgba(255,255,255,0.06)",backdropFilter:"blur(4px)"}}>
                <div style={{fontSize:48,opacity:0.5}}>🖼️</div>
                <p style={{color:"rgba(255,255,255,0.45)",fontSize:13,fontWeight:600,textAlign:"center",margin:0}}>Slide {cur+1} Image</p>
                <p style={{color:"rgba(255,255,255,0.3)",fontSize:11,textAlign:"center",margin:0,padding:"0 24px"}}>Set <code style={{background:"rgba(255,255,255,0.1)",padding:"2px 6px",borderRadius:4}}>slideImage</code> in SLIDES data</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Nav row: arrows + dots */}
      <div className="hero-nav-row">
        <button className="hero-arrow" onClick={()=>{go((cur-1+SLIDES.length)%SLIDES.length);startTimer();}}>‹</button>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          {SLIDES.map((_,i)=>(
            <button key={i} className="hero-dot-btn"
              onClick={()=>{go(i);startTimer();}}
              style={{width:i===cur?28:10,height:10,background:i===cur?"#fff":"rgba(255,255,255,0.35)"}}
            />
          ))}
        </div>
        <button className="hero-arrow" onClick={()=>{go((cur+1)%SLIDES.length);startTimer();}}>›</button>
      </div>

      {/* Progress bar */}
      <div className="hero-progress">
        <div key={animKey} style={{height:"100%",background:s.accent,animation:"progressBar 5.5s linear",width:"100%"}}/>
      </div>
    </section>
  );
}



/* ── NAVBAR (premium, centered menu) ── */
function NavBar({ page, setPage, cartCount, setCartOpen }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const links = ["Home","Seeds","Fertilizers","Crop Protection","Advisory","Blog","Contact"];

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  return (
    <header className={`navbar-wrap${scrolled?" scrolled":""}`}>

      <div className="navbar-row">
        {/* Logo (left) — swap to white version when scrolled */}
        <div onClick={()=>{setPage("home");setMenuOpen(false);}} style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer",justifySelf:"start"}}>
          <img src={scrolled?vsolai1:vsolai3} alt="V-Solai logo" style={{width:200,height:64,objectFit:"contain",transition:"opacity 0.3s"}}/>
        </div>

        {/* Desktop Nav — perfectly centered */}
        <nav className="nav-links-center">
          {links.map(l=>{
            const k=l.toLowerCase().replace(" ","-");
            const active=page===k;
            return (
              <button key={l} onClick={()=>setPage(k)} className={`nav-link-btn${active?" active":""}`} style={{
                fontWeight:active?700:600,
                color:scrolled?"rgba(255,255,255,0.92)":(active?T.emerald:T.slate),
              }}>{l}</button>
            );
          })}
        </nav>

        {/* Actions (right) */}
        <div className="nav-actions">
          <button onClick={()=>setCartOpen(true)} style={{
            background:scrolled?"rgba(255,255,255,0.18)":G.leaf,
            color:"#fff",
            border:scrolled?"1.5px solid rgba(255,255,255,0.35)":"none",
            borderRadius:24,
            padding:"9px 18px",fontSize:13,fontWeight:700,cursor:"pointer",
            display:"flex",alignItems:"center",gap:7,
            boxShadow:scrolled?"none":`0 4px 14px ${T.emerald}4a`,flexShrink:0,transition:"all 0.3s",
          }}
            onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-1px)";}}
            onMouseLeave={e=>{e.currentTarget.style.transform="none";}}>
            <i class="fa-solid fa-cart-arrow-down"></i>
            {cartCount>0&&<span style={{background:T.goldLight,color:T.charcoal,borderRadius:20,width:19,height:19,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:800}}>{cartCount}</span>}
            <span style={{display:"inline"}}>Cart</span>
          </button>

          {/* Hamburger */}
          <button className="nav-mobile-btn" onClick={()=>setMenuOpen(m=>!m)} style={{
            display:"none",background:"none",
            border:scrolled?"1.5px solid rgba(255,255,255,0.4)":`1.5px solid ${T.border}`,
            borderRadius:8,width:38,height:38,cursor:"pointer",flexShrink:0,
            alignItems:"center",justifyContent:"center",fontSize:18,
            color:scrolled?"#fff":T.slate,
          }}>{menuOpen?"✕":"☰"}</button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen&&(
        <div style={{background:scrolled?"rgba(74,34,8,0.97)":"#fff",borderTop:`1px solid ${scrolled?"rgba(255,255,255,0.12)":T.border}`,padding:"12px 16px 20px",animation:"mobileMenu 0.2s ease"}}>
          {links.map(l=>{
            const k=l.toLowerCase().replace(" ","-");
            return (
              <button key={l} onClick={()=>{setPage(k);setMenuOpen(false);}} style={{
                display:"block",width:"100%",textAlign:"left",padding:"12px 16px",
                background:page===k?(scrolled?"rgba(255,255,255,0.15)":T.mint):"transparent",
                color:scrolled?(page===k?"#fff":"rgba(255,255,255,0.78)"):(page===k?T.emerald:T.slate),
                border:"none",borderRadius:8,fontSize:14,fontWeight:page===k?700:500,cursor:"pointer",
                marginBottom:4,
              }}>{l}</button>
            );
          })}
        </div>
      )}
    </header>
  );
}

/* ── SECTION HEADER ── */
/* ── ICON HELPERS ──
   isImagePath(): tells a future imported image apart from today's
   emoji/text placeholders, so every icon slot can take either.
   IconBox(): the single component every icon/logo slot renders
   through — swap a data array's `icon`/`logo` value from an emoji
   to an imported image file and it just works, no markup changes. */
function isImagePath(val) {
  if (!val || typeof val !== "string") return false;
  return /\.(png|jpe?g|svg|webp|gif|avif)(\?.*)?$/i.test(val)
    || val.startsWith("http://") || val.startsWith("https://")
    || val.startsWith("data:image") || val.startsWith("blob:")
    || val.startsWith("/");
}
function IconBox({ icon, size=22, box=42, bg=T.mint, radius=9, alt="", padding, style }) {
  const img = isImagePath(icon);
  // Only fall back to a white card behind the image when the caller hasn't
  // explicitly asked for a transparent background (e.g. hero stat icons,
  // footer/contact icons) — this is what was forcing a white square behind
  // every uploaded icon image regardless of the bg prop passed in.
  const resolvedBg = img && bg !== "transparent" ? "#fff" : bg;
  // Images got extra inner padding by default (shrinking them vs. emoji,
  // which render at the full fontSize) — only auto-pad when sitting on a
  // visible card background; full-bleed when transparent, same as emoji.
  const resolvedPadding = padding ?? (img && bg !== "transparent" ? Math.round(box*0.16) : 0);
  return (
    <div className="icon-box" style={{
      width:box, height:box, background:resolvedBg, borderRadius:radius,
      fontSize:size, padding:resolvedPadding,
      ...style,
    }}>
      {img ? <img src={icon} alt={alt}/> : icon}
    </div>
  );
}

function SH({ eyebrow, title, sub, left }) {
  return (
    <div style={{textAlign:left?"left":"center",marginBottom:36}}>
      {eyebrow&&<p style={{fontSize:11,letterSpacing:"2.5px",textTransform:"uppercase",color:T.emerald,fontWeight:700,margin:"0 0 10px"}}>{eyebrow}</p>}
      <h2 className="section-h2" style={{fontSize:28,fontWeight:900,color:T.charcoal,margin:"0 0 10px",letterSpacing:"-0.5px"}}>{title}</h2>
      {sub&&<p style={{fontSize:14,color:T.slate,margin:left?"0":"0 auto",lineHeight:1.7,maxWidth:520}}>{sub}</p>}
    </div>
  );
}

/* ── PRODUCT CARD ── */
function ProductCard({ p, onAdd }) {
  const [hov,setHov]=useState(false);
  const [imgErr,setImgErr]=useState(false);
  const disc=Math.round(((p.mrp-p.price)/p.mrp)*100);
  const bc={Bestseller:T.emerald,New:T.info,Hot:T.danger,Premium:"#7c3aed",Popular:"#0891b2",Organic:"#16a34a"};
  return (
    <div style={{background:"#fff",borderRadius:14,border:`1px solid ${hov?"#a8d5a0":T.border}`,overflow:"hidden",transition:"all 0.22s",cursor:"pointer",transform:hov?"translateY(-5px)":"none",boxShadow:hov?"0 14px 36px rgba(163,93,23,0.13)":"0 2px 6px rgba(0,0,0,0.04)"}}
      onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}>
      <div style={{height:300,background:G.card,display:"flex",alignItems:"center",justifyContent:"center",fontSize:72,position:"relative",overflow:"hidden"}}>
        {p.image&&!imgErr?(
          <img src={p.image} alt={p.name} onError={()=>setImgErr(true)}
            style={{width:"100%",height:"100%",objectFit:"cover",transition:"transform 0.3s",transform:hov?"scale(1.05)":"scale(1)"}}/>
        ):(
          <i className={`fa-solid ${p.icon}`} style={{fontSize:56,color:T.emerald}}/>
        )}
        {p.badge&&<span style={{position:"absolute",top:10,left:10,background:bc[p.badge]||T.emerald,color:"#fff",fontSize:9,fontWeight:800,padding:"3px 8px",borderRadius:20,letterSpacing:"0.8px",textTransform:"uppercase"}}>{p.badge}</span>}
        <span style={{position:"absolute",top:10,right:10,background:T.danger,color:"#fff",fontSize:10,fontWeight:800,padding:"3px 6px",borderRadius:6}}>-{disc}%</span>
      </div>
      <div style={{padding:"14px 16px"}}>
        <p style={{fontSize:10,color:T.muted,margin:"0 0 4px",textTransform:"capitalize",letterSpacing:"0.5px"}}>{p.cat.replace("-"," ")}</p>
        <h3 style={{fontSize:13,fontWeight:700,color:T.charcoal,margin:"0 0 6px",lineHeight:1.4}}>{p.name}</h3>
        <div style={{display:"flex",alignItems:"center",gap:5,marginBottom:8}}>
          <span style={{fontSize:11,color:T.gold}}>{"★".repeat(Math.floor(p.rating))}{"☆".repeat(5-Math.floor(p.rating))}</span>
          <span style={{fontSize:10,color:T.muted}}>({p.rev})</span>
        </div>
        <p style={{fontSize:11,color:T.slate,lineHeight:1.5,margin:"0 0 14px"}}>{p.desc}</p>
        <button onClick={e=>{e.stopPropagation();onAdd(p);}} style={{
          width:"100%",
          background:hov?T.forest:"transparent",
          color:hov?"#fff":T.forest,
          border:`1.5px solid ${T.forest}`,
          borderRadius:8,padding:"9px 14px",
          fontSize:12,fontWeight:700,cursor:"pointer",
          display:"flex",alignItems:"center",justifyContent:"center",gap:6,
          transition:"all 0.22s",letterSpacing:"0.2px",
        }}>
          View Details <span style={{fontSize:14,transition:"transform 0.22s",transform:hov?"translateX(3px)":"none",display:"inline-block"}}>→</span>
        </button>
      </div>
    </div>
  );
}

/* ── CART ITEM ── */
function CartItem({ item, onQty, onRemove }) {
  const [imgErr,setImgErr]=useState(false);
  return (
    <div style={{marginBottom:16,paddingBottom:16,borderBottom:`1px solid ${T.border}`}}>
      {/* Product Image */}
      <div style={{width:"100%",height:180,borderRadius:10,overflow:"hidden",background:G.card,marginBottom:12,display:"flex",alignItems:"center",justifyContent:"center",fontSize:64}}>
        {item.image&&!imgErr?(
          <img src={item.image} alt={item.name} onError={()=>setImgErr(true)}
            style={{width:"100%",height:"100%",objectFit:"cover"}}/>
        ):(
          <i className={`fa-solid ${item.icon}`} style={{fontSize:56,color:T.emerald}}/>
        )}
      </div>
      {/* Name + Unit */}
      <div style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",gap:10}}>
        <div style={{flex:1}}>
          <p style={{margin:"0 0 4px",fontSize:14,fontWeight:700,color:T.charcoal,lineHeight:1.4}}>{item.name}</p>
          <p style={{margin:"0 0 10px",fontSize:12,color:T.slate,fontWeight:500}}>Unit: {item.unit}</p>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <button onClick={()=>onQty(item.id,-1)} style={{width:28,height:28,border:`1px solid ${T.border}`,background:"#fff",borderRadius:6,cursor:"pointer",fontSize:16,fontWeight:700,color:T.forest}}>−</button>
            <span style={{fontSize:14,fontWeight:700,color:T.charcoal,minWidth:20,textAlign:"center"}}>{item.qty}</span>
            <button onClick={()=>onQty(item.id,1)} style={{width:28,height:28,border:`1px solid ${T.border}`,background:"#fff",borderRadius:6,cursor:"pointer",fontSize:16,fontWeight:700,color:T.forest}}>+</button>
          </div>
        </div>
        <button onClick={()=>onRemove(item.id)} style={{background:"none",border:"none",color:"#ef4444",cursor:"pointer",fontSize:16,flexShrink:0,padding:"2px 4px"}}>🗑</button>
      </div>
      {/* Price info — hidden, preserved for future */}
      <div style={{display:"none"}}>
        <span className="item-price">₹{item.price} / {item.unit}</span>
        <span className="item-subtotal">₹{(item.price*item.qty).toLocaleString()}</span>
      </div>
    </div>
  );
}

/* ── CART DRAWER ── */
function CartDrawer({ cart, onClose, onRemove, onQty }) {
  const total=cart.reduce((s,i)=>s+i.price*i.qty,0);
  const count=cart.reduce((s,i)=>s+i.qty,0);
  const delivery = total>=500||total===0 ? 0 : 50;
  const checkoutOnWhatsApp = () => {
    if (cart.length===0) return;
    const lines = cart.map((item,idx)=>
      `${idx+1}. ${item.name} (${item.unit})\n   Qty: ${item.qty} × ₹${item.price} = ₹${(item.price*item.qty).toLocaleString()}`
    ).join("\n\n");
    const message =
`🛒 *New Order – V-Solai*

${lines}

────────────
Subtotal: ₹${total.toLocaleString()}
Delivery: ${delivery===0?"FREE":"₹"+delivery}
*Total: ₹${(total+delivery).toLocaleString()}*

Please confirm my order and let me know the next steps.`;
    sendWhatsApp(message);
  };
  return (
    <div className="cart-drawer" style={{position:"fixed",top:0,right:0,width:370,height:"100vh",background:"#fff",boxShadow:"-6px 0 32px rgba(0,0,0,0.13)",zIndex:1000,display:"flex",flexDirection:"column"}}>
      {/* Header */}
      <div style={{padding:"18px 22px",borderBottom:`1px solid ${T.border}`,background:T.mint,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <h2 style={{margin:0,fontSize:16,fontWeight:800,color:T.forest}}>Product Details</h2>
          <p style={{margin:0,fontSize:11,color:T.slate}}>{count} item{count!==1?"s":""} selected</p>
        </div>
        <button onClick={onClose} style={{background:"#fff",border:`1px solid ${T.border}`,width:32,height:32,borderRadius:8,cursor:"pointer",fontSize:15,color:T.slate}}>✕</button>
      </div>

      {/* Items */}
      <div style={{flex:1,overflowY:"auto",padding:"14px 22px"}}>
        {cart.length===0?(
          <div style={{textAlign:"center",padding:"60px 0",color:T.muted}}>
            <div style={{fontSize:52,marginBottom:12}}>🛒</div>
            <p style={{fontWeight:600,color:T.slate}}>No products selected</p>
          </div>
        ):cart.map(item=>(
          <CartItem key={item.id} item={item} onQty={onQty} onRemove={onRemove}/>
        ))}
      </div>

      {/* Footer — only WhatsApp button, price rows hidden */}
      <div style={{padding:"18px 22px",borderTop:`1px solid ${T.border}`}}>
        {/* Price rows preserved but hidden for future use */}
        <div style={{display:"none"}}>
          <div className="subtotal-row" style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
            <span style={{fontSize:13,color:T.slate}}>Subtotal</span>
            <span style={{fontSize:13,fontWeight:700}}>₹{total.toLocaleString()}</span>
          </div>
          <div className="delivery-row" style={{display:"flex",justifyContent:"space-between",marginBottom:16}}>
            <span style={{fontSize:13,color:T.slate}}>Delivery</span>
            <span style={{fontSize:13,color:total>=500?"#16a34a":T.slate,fontWeight:600}}>{total>=500?"FREE ✓":"₹50"}</span>
          </div>
          {total>0&&total<500&&<p className="free-delivery-msg" style={{fontSize:11,color:T.emerald,marginBottom:12,textAlign:"center"}}>Add ₹{500-total} more for free delivery!</p>}
        </div>

        <button onClick={checkoutOnWhatsApp} disabled={cart.length===0} style={{width:"100%",background:cart.length===0?T.muted:G.gold,color:T.charcoal,border:"none",borderRadius:10,padding:"13px",fontSize:15,fontWeight:800,cursor:cart.length===0?"not-allowed":"pointer",boxShadow:cart.length===0?"none":`0 4px 14px rgba(0,0,0,0.18)`,display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
          <img src={wa} alt="" style={{width:18,height:18}}/> Checkout on WhatsApp
        </button>
      </div>
    </div>
  );
}

/* ══════════════ PAGES ══════════════ */

function HomePage({ setPage, onAdd }) {
  const featured=PRODUCTS.filter(p=>["Bestseller","Hot","Premium"].includes(p.badge)).slice(0,4);
  return (
    <div>
      <HeroSlider setPage={setPage}/>

      {/* Featured */}
      <section className="section-pad" style={{padding:"64px 28px"}}>
        <div style={{maxWidth:1320,margin:"0 auto"}}>
          <SH eyebrow="Top Picks" title="Featured Products" sub="Hand-picked bestsellers trusted by thousands of Tamil Nadu farmers."/>
          <div className="prod-grid" style={{display:"flex",flexWrap:"wrap",gap:20,justifyContent:"center"}}>
            {featured.map(p=><div key={p.id} className="prod-card-wrap" style={{width:"calc(25% - 15px)",minWidth:220,maxWidth:300,flexGrow:0,flexShrink:0}}><ProductCard p={p} onAdd={onAdd}/></div>)}
          </div>
          <div style={{textAlign:"center",marginTop:32}}>
            <button onClick={()=>setPage("seeds")} style={{background:"transparent",color:T.emerald,border:`2px solid ${T.emerald}`,borderRadius:10,padding:"11px 26px",fontSize:14,fontWeight:700,cursor:"pointer"}}>View All Products →</button>
          </div>
        </div>
      </section>

      {/* Categories */}
      <section style={{background:T.mint,padding:"64px 28px"}} className="section-pad">
        <div style={{maxWidth:1320,margin:"0 auto"}}>
          <SH eyebrow="Shop By Category" title="Everything Your Farm Needs" sub="From certified seeds to precision equipment — all under one roof."/>
          <div className="four-col" style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:18}}>
            {[
              {icon:sprout,title:"Seeds",sub:"Hybrid & open-pollinated for paddy, vegetables, field crops.",color:T.emerald,pg:"seeds"},
              {icon:fertilizer,title:"Fertilizers",sub:"NPK, micronutrients & bio-stimulants for complete nutrition.",color:"#A35D17",pg:"fertilizers"},
              {icon:crop,title:"Crop Protection",sub:"Insecticides, fungicides & herbicides from top brands.",color:"#A35D17",pg:"crop-protection"},
              {icon:equi,title:"Equipment",sub:"Sprayers, tools & machinery for modern farm efficiency.",color:"#A35D17",pg:"seeds"},
            ].map(c=>(
              <div key={c.title} onClick={()=>setPage(c.pg)} style={{background:"#fff",borderRadius:14,padding:"24px 18px",cursor:"pointer",border:"1.5px solid transparent",transition:"all 0.2s",boxShadow:"0 2px 6px rgba(0,0,0,0.04)"}}
                onMouseEnter={e=>{e.currentTarget.style.borderColor=c.color;e.currentTarget.style.transform="translateY(-4px)";}}
                onMouseLeave={e=>{e.currentTarget.style.borderColor="transparent";e.currentTarget.style.transform="none";}}>
                <IconBox icon={c.icon} box={68} size={36} bg={c.color+"15"} radius={10} style={{marginBottom:14}}/>
                <h3 style={{fontSize:15,fontWeight:800,color:T.charcoal,margin:"0 0 7px"}}>{c.title}</h3>
                <p style={{fontSize:12,color:T.slate,lineHeight:1.6,margin:"0 0 14px"}}>{c.sub}</p>
                <span style={{fontSize:12,fontWeight:700,color:c.color}}>Shop {c.title} →</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Seasonal Banner */}
      <section style={{padding:"64px 28px"}} className="section-pad">
        <div style={{maxWidth:1320,margin:"0 auto"}}>
        <div style={{background:G.hero,borderRadius:18,padding:"52px 44px",color:"#fff",display:"grid",gridTemplateColumns:"1fr 1fr",gap:36,alignItems:"center",overflow:"hidden",position:"relative"}} className="two-col seasonal-grid">
          <div style={{position:"absolute",right:-40,top:-40,width:260,height:260,borderRadius:"50%",background:"rgba(255,255,255,0.07)"}}/>
          <div style={{position:"relative"}}>
            <p style={{fontSize:10,letterSpacing:"2px",color:T.goldLight,fontWeight:700,margin:"0 0 10px"}}>KHARIF 2024</p>
            <h2 style={{fontSize:26,fontWeight:900,margin:"0 0 14px",lineHeight:1.2}}>Seasonal Crop Advisory Available Now</h2>
            <p style={{color:"rgba(255,255,255,0.7)",lineHeight:1.7,margin:"0 0 24px",fontSize:14}}>Personalized recommendations for your soil, crop variety & local weather from certified agronomists.</p>
            <button onClick={()=>setPage("advisory")} style={{background:G.gold,color:T.charcoal,border:"none",borderRadius:9,padding:"12px 24px",fontSize:13,fontWeight:800,cursor:"pointer"}}>Get Free Advisory →</button>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}} className="seasonal-mini">
  {[
    ["fa-seedling",   "Paddy",     "July–Nov"],
    ["fa-leaf",       "Vegetables","Aug–Dec"],
    ["fa-wheat-awn",       "Maize",     "June–Sep"],
    ["fa-plant-wilt","Groundnut", "June–Oct"]
  ].map(([e,n,t])=>(
    <div key={n} style={{background:"rgba(255,255,255,0.09)",border:"1px solid rgba(255,255,255,0.12)",borderRadius:10,padding:"16px 12px"}}>
      <IconBox icon={<i className={`fa-solid ${e}`}/>} box={30} size={26} bg="transparent" radius={0} style={{marginBottom:6}}/>
      <div style={{fontSize:12,fontWeight:700}}>{n}</div>
      <div style={{fontSize:10,color:T.goldLight,marginTop:3}}>{t}</div>
    </div>
  ))}
</div>
        </div>
        </div>
      </section>

      {/* Brands */}
      <section style={{background:T.mint,padding:"52px 28px"}} className="section-pad">
        <div style={{maxWidth:1320,margin:"0 auto"}}>
          <SH eyebrow="Our Partners" title="Trusted Brands We Retail"/>
          <div className="brands-grid" style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(170px,1fr))",gap:18}}>
            {BRANDS.map(b=>(
              <div key={b.name} className="retailer-card">
                {b.logo ? (
                  <img src={b.logo} alt={`${b.name} logo`}/>
                ) : (
                  <span className="retailer-wordmark" style={{color:b.color}}>{b.name}</span>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section style={{padding:"64px 28px"}} className="section-pad">
        <div style={{maxWidth:1320,margin:"0 auto"}}>
          <SH eyebrow="Farmer Stories" title="Trusted Across Tamil Nadu"/>
          <div className="four-col" style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:18}}>
            {TESTIMONIALS.map(t=>(
              <div key={t.name} style={{background:"#fff",borderRadius:14,padding:"22px",border:`1px solid ${T.border}`,boxShadow:"0 2px 6px rgba(0,0,0,0.04)"}}>
                <div style={{fontSize:13,color:T.gold,marginBottom:10}}>{"★".repeat(t.rating)}</div>
                <p style={{fontSize:13,lineHeight:1.75,color:T.slate,margin:"0 0 18px",fontStyle:"italic"}}>"{t.text}"</p>
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <div style={{width:38,height:38,borderRadius:"50%",background:G.leaf,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:800,fontSize:15,flexShrink:0}}>{t.name[0]}</div>
                  <div>
                    <div style={{fontWeight:700,fontSize:13,color:T.charcoal}}>{t.name}</div>
                    <div style={{fontSize:10,color:T.muted}}>{t.crop} · {t.loc}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

function ShopPage({ onAdd, filterCat }) {
  const [cat,setCat]=useState(filterCat||"all");
  const [search,setSearch]=useState("");
  const [sort,setSort]=useState("default");
  useEffect(()=>{ if(filterCat) setCat(filterCat); },[filterCat]);

  const cats=[
  {id:"all",          icon:null,                                        label:"All"},
  {id:"seeds",        icon:<i className="fa-solid fa-seedling"/>,       label:"Seeds"},
  {id:"fertilizers",  icon:<i className="fa-solid fa-flask"/>,          label:"Fertilizers"},
  {id:"protection",   icon:<i className="fa-solid fa-shield"/>,         label:"Protection"},
  {id:"equipment",    icon:<i className="fa-solid fa-tractor"/>,        label:"Equipment"}
];

  let list=PRODUCTS.filter(p=>{
    const mc=cat==="all"||p.cat===cat;
    const ms=p.name.toLowerCase().includes(search.toLowerCase());
    return mc&&ms;
  });
  if(sort==="price-asc") list=[...list].sort((a,b)=>a.price-b.price);
  if(sort==="price-desc") list=[...list].sort((a,b)=>b.price-a.price);
  if(sort==="rating") list=[...list].sort((a,b)=>b.rating-a.rating);

  return (
    <section style={{padding:"48px 20px"}} className="section-pad">
      <div style={{maxWidth:1320,margin:"0 auto"}}>
      <SH eyebrow="Our Products" title="Shop Agricultural Inputs" sub="200+ genuine products — seeds, fertilizers, crop protection & equipment." left/>
      <div style={{display:"flex",gap:10,marginBottom:22,flexWrap:"wrap",alignItems:"center"}}>
        <div style={{display:"flex",gap:7,flexWrap:"wrap",flex:1}}>
          {cats.map(c=>(
            <button key={c.id} onClick={()=>setCat(c.id)} style={{display:"inline-flex",alignItems:"center",gap:6,padding:"7px 15px",borderRadius:20,fontSize:12,cursor:"pointer",background:cat===c.id?T.emerald:"#fff",color:cat===c.id?"#fff":T.slate,border:`1.5px solid ${cat===c.id?T.emerald:T.border}`,fontWeight:cat===c.id?700:500,transition:"all 0.15s"}}>
              {c.icon&&<IconBox icon={c.icon} box={15} size={13} bg="transparent" radius={0}/>}
              {c.label}
            </button>
          ))}
        </div>
        <div style={{position:"relative",display:"inline-flex",alignItems:"center"}}>
  <i className="fa-solid fa-magnifying-glass" style={{position:"absolute",left:10,color:T.muted,fontSize:12,pointerEvents:"none"}}/>
  <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search..." style={{padding:"8px 13px 8px 28px",border:`1.5px solid ${T.border}`,borderRadius:20,fontSize:13,outline:"none",width:160}}/>
</div>
        <select value={sort} onChange={e=>setSort(e.target.value)} style={{padding:"8px 12px",border:`1.5px solid ${T.border}`,borderRadius:20,fontSize:12,outline:"none",background:"#fff",cursor:"pointer"}}>
          <option value="default">Sort</option>
          <option value="price-asc">Price ↑</option>
          <option value="price-desc">Price ↓</option>
          <option value="rating">Rating</option>
        </select>
      </div>
      <p style={{fontSize:12,color:T.muted,marginBottom:20}}>{list.length} products</p>
      {list.length>0?(
        <div className="prod-grid" style={{display:"flex",flexWrap:"wrap",gap:18,justifyContent:"center"}}>
          {list.map(p=><div key={p.id} className="prod-card-wrap" style={{width:"calc(25% - 14px)",minWidth:220,maxWidth:300,flexGrow:0,flexShrink:0}}><ProductCard p={p} onAdd={onAdd}/></div>)}
        </div>
      ):(
        <div style={{textAlign:"center",padding:"80px 0",color:T.muted}}>
          <div style={{fontSize:48,marginBottom:12}}>🔍</div>
          <p style={{fontSize:15,color:T.slate,fontWeight:600}}>No products found</p>
        </div>
      )}
      </div>
    </section>
  );
}

function AdvisoryPage() {
  const [form,setForm]=useState({name:"",phone:"",crop:"",type:"",query:""});
  const [submitted,setSubmitted]=useState(false);
  const inp={padding:"11px 14px",border:`1.5px solid ${T.border}`,borderRadius:9,fontSize:14,outline:"none",width:"100%",boxSizing:"border-box",background:"#fff"};
  const hc=k=>e=>setForm(f=>({...f,[k]:e.target.value}));
  const submit=()=>{
    if(!(form.name&&form.phone&&form.crop)) return;
    const message =
`🌱 *Free Advisory Request – V-Solai*

Name: ${form.name}
Phone: ${form.phone}
Crop: ${form.crop}
Advisory Type: ${form.type||"Not specified"}
Query: ${form.query||"—"}`;
    sendWhatsApp(message);
    setSubmitted(true);
  };

  return (
    <div>
      {/* ── Advisory Hero Slider at top ── */}
      <section style={{background:G.hero,color:"#fff",padding:"64px 20px",textAlign:"center"}}>
        <div style={{maxWidth:560,margin:"0 auto"}}>
          <p style={{fontSize:10,letterSpacing:"2.5px",color:T.goldLight,fontWeight:700,margin:"0 0 12px"}}>ADVISORY</p>
          <h1 className="page-hero-h1" style={{fontSize:36,fontWeight:900,margin:"0 0 14px"}}>Farm Advisory & Support</h1>
          <p style={{fontSize:14,color:"rgba(255,255,255,0.7)",lineHeight:1.75}}>Personalized guidance, field visits & expert recommendations from our advisory team.</p>
        </div>
      </section>

      <section style={{padding:"64px 20px"}} className="section-pad">
      <div style={{maxWidth:1320,margin:"0 auto"}}>
        {/* Experts */}
        <SH eyebrow="Our Team" title="Meet Our Agronomists" sub="15+ years of combined experience serving Tamil Nadu farmers."/>
        <div className="three-col" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:18,marginBottom:64}}>
          {ADVISORS.map(a=>(
            <div key={a.name} style={{background:"#fff",borderRadius:14,padding:"26px",border:`1px solid ${T.border}`,textAlign:"center",boxShadow:"0 2px 6px rgba(0,0,0,0.04)"}}>
              
              <h3 style={{fontSize:15,fontWeight:800,color:T.charcoal,margin:"0 0 4px"}}>{a.name}</h3>
              <p style={{fontSize:12,color:T.emerald,fontWeight:600,margin:"0 0 6px"}}>{a.title}</p>
              <p style={{fontSize:11,color:T.slate,margin:"0 0 4px"}}>{a.exp} experience</p>
              <p style={{fontSize:11,color:T.muted}}>{a.spec}</p>
            </div>
          ))}
        </div>

        {/* Form + Services */}
        <div className="advisory-layout" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:44,alignItems:"start"}}>
          <div style={{background:"#fff",borderRadius:16,padding:"32px",border:`1px solid ${T.border}`,boxShadow:"0 4px 14px rgba(0,0,0,0.05)"}}>
            <SH eyebrow="Book Free Session" title="Get Expert Crop Advice" left/>
            {submitted?(
              <div style={{textAlign:"center",padding:"32px 0"}}>
                <div style={{fontSize:48,marginBottom:12}}>✅</div>
                <h3 style={{color:T.forest,fontWeight:800,margin:"0 0 8px"}}>Request Submitted!</h3>
                <p style={{color:T.slate,fontSize:14}}>We've opened WhatsApp with your details. Our agronomist will also call {form.phone} within 24 hours.</p>
              </div>
            ):(
              <div style={{display:"flex",flexDirection:"column",gap:12}}>
                <input style={inp} placeholder="Your Name *" value={form.name} onChange={hc("name")}/>
                <input style={inp} placeholder="Phone Number *" value={form.phone} onChange={hc("phone")}/>
                <input style={inp} placeholder="Crop you're growing *" value={form.crop} onChange={hc("crop")}/>
                <select style={{...inp,cursor:"pointer"}} value={form.type} onChange={hc("type")}>
                  <option value="">Advisory Type</option>
                  <option>Seed Selection</option>
                  <option>Pest & Disease Management</option>
                  <option>Fertilizer Schedule</option>
                  <option>Soil Health</option>
                  <option>General Advice</option>
                </select>
                <textarea style={{...inp,minHeight:90,resize:"vertical"}} placeholder="Describe your issue..." value={form.query} onChange={hc("query")}/>
                <button onClick={submit} style={{background:G.leaf,color:"#fff",border:"none",borderRadius:10,padding:"13px",fontSize:14,fontWeight:800,cursor:"pointer",boxShadow:`0 4px 14px ${T.emerald}44`,display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
                   Request Free Advisory on WhatsApp
                </button>
              </div>
            )}
          </div>
          <div>
            <SH eyebrow="Services" title="What We Offer" left/>
            {[
              {icon:<i className="fa-solid fa-seedling"/>,     title:"Crop Calendar Planning",   sub:"Season-specific planting schedules and input timelines for your region."},
              {icon:<i className="fa-solid fa-bug"/>,          title:"Pest & Disease ID",         sub:"Send photos of affected plants — get same-day diagnosis and treatment."},
              {icon:<i className="fa-solid fa-flask"/>,        title:"Soil Health Assessment",    sub:"Soil test interpretation and fertilizer schedule planning."},
              {icon:<i className="fa-solid fa-droplet"/>,      title:"Irrigation Advisory",       sub:"Water management for drip, sprinkler, and flood irrigation systems."},
            ].map(s=>(
              <div key={s.title} style={{display:"flex",gap:14,marginBottom:20,padding:"16px",background:"#fff",borderRadius:12,border:`1px solid ${T.border}`}}>
                <IconBox icon={s.icon} box={42} size={20} radius={9}/>
                <div>
                  <h4 style={{fontSize:13,fontWeight:700,color:T.charcoal,margin:"0 0 4px"}}>{s.title}</h4>
                  <p style={{fontSize:12,color:T.slate,margin:0,lineHeight:1.6}}>{s.sub}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      </section>
    </div>
  );
}

function BlogPage() {
  return (
    <div>
      <section style={{background:G.hero,color:"#fff",padding:"64px 20px",textAlign:"center"}}>
        <div style={{maxWidth:560,margin:"0 auto"}}>
          <p style={{fontSize:10,letterSpacing:"2.5px",color:T.goldLight,fontWeight:700,margin:"0 0 12px"}}>KNOWLEDGE HUB</p>
          <h1 className="page-hero-h1" style={{fontSize:36,fontWeight:900,margin:"0 0 14px"}}>Farm Knowledge & Insights</h1>
          <p style={{fontSize:14,color:"rgba(255,255,255,0.7)",lineHeight:1.75}}>Expert articles, crop guides & agronomy tips from our specialist team.</p>
        </div>
      </section>
      <section style={{padding:"64px 20px"}} className="section-pad">
      <div style={{maxWidth:1320,margin:"0 auto"}}>
        <div className="three-col" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:22}}>
          {BLOG_POSTS.map(b=>(
            <div key={b.id} style={{background:"#fff",borderRadius:14,overflow:"hidden",border:`1px solid ${T.border}`,boxShadow:"0 2px 6px rgba(0,0,0,0.04)",cursor:"pointer",transition:"all 0.2s"}}
              onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-4px)";e.currentTarget.style.boxShadow="0 12px 30px rgba(163,93,23,0.10)";}}
              onMouseLeave={e=>{e.currentTarget.style.transform="none";e.currentTarget.style.boxShadow="0 2px 6px rgba(0,0,0,0.04)";}}>
              <div style={{height:160,background:G.card,display:"flex",alignItems:"center",justifyContent:"center"}}>
                <IconBox icon={b.icon} box={84} size={60} bg="transparent" radius={0}/>
              </div>
              <div style={{padding:"20px"}}>
                <div style={{display:"flex",gap:8,marginBottom:10}}>
                  <span style={{background:T.mint,color:T.emerald,fontSize:10,fontWeight:700,padding:"3px 10px",borderRadius:20}}>{b.tag}</span>
                  <span style={{color:T.muted,fontSize:11,padding:"3px 0"}}>{b.readTime} read</span>
                </div>
                <h3 style={{fontSize:15,fontWeight:800,color:T.charcoal,margin:"0 0 8px",lineHeight:1.4}}>{b.title}</h3>
                <p style={{fontSize:12,color:T.slate,lineHeight:1.65,margin:"0 0 14px"}}>{b.excerpt}</p>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span style={{fontSize:11,color:T.muted}}>{b.date}</span>
                  <span style={{fontSize:12,fontWeight:700,color:T.emerald}}>Read →</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div style={{marginTop:52}}>
          <SH eyebrow="Topics" title="Browse by Category"/>
          <div style={{display:"flex",gap:10,justifyContent:"center",flexWrap:"wrap"}}>
            {["Paddy","Vegetables","Fruits","Fertilizers","Pest Control","Soil Health","Irrigation","Organic Farming"].map(t=>(
              <button key={t} style={{padding:"9px 18px",borderRadius:20,border:`1.5px solid ${T.border}`,background:"#fff",fontSize:12,fontWeight:600,color:T.slate,cursor:"pointer",transition:"all 0.15s"}}
                onMouseEnter={e=>{e.target.style.borderColor=T.emerald;e.target.style.color=T.emerald;}}
                onMouseLeave={e=>{e.target.style.borderColor=T.border;e.target.style.color=T.slate;}}>{t}</button>
            ))}
          </div>
        </div>
      </div>
      </section>
    </div>
  );
}

function ContactPage() {
  const [form,setForm]=useState({name:"",phone:"",email:"",msg:""});
  const [submitted,setSubmitted]=useState(false);
  const inp={padding:"11px 14px",border:`1.5px solid ${T.border}`,borderRadius:9,fontSize:14,outline:"none",width:"100%",boxSizing:"border-box",background:"#fff"};
  const hc=k=>e=>setForm(f=>({...f,[k]:e.target.value}));
  const submit=()=>{
    if(!(form.name&&form.phone)) return;
    const message =
`📩 *Quick Inquiry – V-Solai*

Name: ${form.name}
Phone: ${form.phone}
Email: ${form.email||"—"}
Message: ${form.msg||"—"}`;
    sendWhatsApp(message);
    setSubmitted(true);
  };

  return (
    <div>
      <section style={{background:G.hero,color:"#fff",padding:"64px 20px",textAlign:"center"}}>
        <div style={{maxWidth:560,margin:"0 auto"}}>
          <p style={{fontSize:10,letterSpacing:"2.5px",color:T.goldLight,fontWeight:700,margin:"0 0 12px"}}>GET IN TOUCH</p>
          <h1 className="page-hero-h1" style={{fontSize:36,fontWeight:900,margin:"0 0 14px"}}>Contact V-Solai</h1>
          <p style={{fontSize:14,color:"rgba(255,255,255,0.7)",lineHeight:1.75}}>Our team is ready to help with product queries, bulk orders & expert advice.</p>
        </div>
      </section>
      <section style={{padding:"64px 20px"}} className="section-pad">
      <div style={{maxWidth:1320,margin:"0 auto"}}>
        <div className="contact-layout" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:44,alignItems:"start"}}>
          <div>
            <SH eyebrow="Reach Us" title="We're Here to Help" left/>
            {[
              {icon:<i className="fa-solid fa-location-dot"/>, title:"Store Address", detail:"579, Mahathma Gandhiji Road, Railady, Koranad, Mayiladuthurai, Tamil Nadu 609003, India"},
              {icon:<i className="fa-solid fa-phone"/>,        title:"Phone",         detail:"+91 98765 43210\n+91 98765 43211"},
              {icon:<i className="fa-solid fa-envelope"/>,     title:"Email",         detail:"info@vsolai.com\nsupport@vsolai.com"},
              {icon:<i className="fa-solid fa-clock"/>,        title:"Working Hours", detail:"Mon–Sat: 8:00 AM – 7:00 PM\nSun: 9:00 AM – 2:00 PM"},
            ].map(i=>(
              <div key={i.title} style={{display:"flex",gap:14,marginBottom:16,padding:"16px 18px",background:"#fff",borderRadius:12,border:`1px solid ${T.border}`}}>
                <IconBox icon={i.icon} box={42} size={20} radius={9}/>
                <div>
                  <h4 style={{fontSize:11,fontWeight:700,color:T.slate,margin:"0 0 4px",textTransform:"uppercase",letterSpacing:"0.5px"}}>{i.title}</h4>
                  <p style={{fontSize:13,color:T.charcoal,margin:0,lineHeight:1.6,whiteSpace:"pre-line"}}>{i.detail}</p>
                </div>
              </div>
            ))}
          </div>
          <div style={{background:"#fff",borderRadius:16,padding:"32px",border:`1px solid ${T.border}`,boxShadow:"0 4px 14px rgba(0,0,0,0.05)"}}>
            <SH eyebrow="Send a Message" title="Quick Inquiry" left/>
            {submitted?(
              <div style={{textAlign:"center",padding:"32px 0"}}>
                <div style={{fontSize:48,marginBottom:12}}>✅</div>
                <h3 style={{color:T.forest,fontWeight:800,margin:"0 0 8px"}}>Message Sent!</h3>
                <p style={{color:T.slate,fontSize:14}}>We've opened WhatsApp with your message. We'll also respond within 24 hours.</p>
              </div>
            ):(
              <div style={{display:"flex",flexDirection:"column",gap:12}}>
                <input style={inp} placeholder="Your Name *" value={form.name} onChange={hc("name")}/>
                <input style={inp} placeholder="Phone Number *" value={form.phone} onChange={hc("phone")}/>
                <input style={inp} placeholder="Email Address" value={form.email} onChange={hc("email")}/>
                <textarea style={{...inp,minHeight:110,resize:"vertical"}} placeholder="Your message or query..." value={form.msg} onChange={hc("msg")}/>
                <button onClick={submit} style={{background:G.leaf,color:"#fff",border:"none",borderRadius:10,padding:"13px",fontSize:14,fontWeight:800,cursor:"pointer",boxShadow:`0 4px 14px ${T.emerald}44`,display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
                   Send Message 
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      </section>
    </div>
  );
}

/* ── FOOTER ── */
function Footer({ setPage }) {
  const linkCols = [
    {title:"Products",links:["Seeds","Fertilizers","Crop Protection","Equipment"],pages:["seeds","fertilizers","crop-protection","seeds"]},
    {title:"Quick Links",links:["Home","Advisory","Blog","Contact"],pages:["home","advisory","blog","contact"]},
  ];
  // 🔖 Swap any emoji below for an imported brand logo (e.g. icon: logoFacebook) once ready.
  const social = [
    {name:"Facebook",  icon:<i className="fa-brands fa-facebook"/>},
    {name:"Instagram", icon:<i className="fa-brands fa-instagram"/>},
    {name:"YouTube",   icon:<i className="fa-brands fa-youtube"/>},
    {name:"WhatsApp",  icon:<i className="fa-brands fa-whatsapp"/>},
  ];
  const contactLines = [
  {icon:<i className="fa-solid fa-location-dot"/>, text:"579, Mahathma Gandhiji Road, Railady, Koranad, Mayiladuthurai, Tamil Nadu 609003, India"},
  {icon:<i className="fa-solid fa-phone"/>,        text:"+91 98765 43210"},
  {icon:<i className="fa-solid fa-envelope"/>,     text:"info@vsolai.com"},
];

  return (
    <footer style={{background:T.forest,color:"#fff",padding:"52px 20px 20px"}}>
      <div style={{maxWidth:1320,margin:"0 auto"}}>
        <div className="footer-grid" style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr",gap:36,marginBottom:44,alignItems:"start"}}>
          <div>
            <div style={{display:"flex",alignItems:"center",gap:9,marginBottom:8}}>
              <img src={vsolai1} alt="V-Solai logo" style={{width:150,height:80,objectFit:"contain"}}/>
            </div>
            <p className="footer-wordmark" style={{fontSize:13.5,color:T.goldLight,margin:"0 0 12px",opacity:0.92}}>Genuine Inputs. Trusted Advice.</p>
            <p className="footer-desc" style={{fontSize:12.5,lineHeight:1.85,opacity:0.72,marginBottom:16}}>Empowering Tamil Nadu farmers with genuine agricultural inputs, expert advisory & certified crop solutions since 2010.</p>
          </div>

          {linkCols.map(col=>(
            <div key={col.title}>
              <h4 className="footer-heading" style={{fontSize:16,letterSpacing:"0.3px",color:T.goldLight,margin:"0 0 16px"}}>{col.title}</h4>
              <div className="footer-links-list">
                {col.links.map((l,i)=>(
                  <p key={l} className="footer-link" onClick={()=>setPage(col.pages[i])} style={{margin:0,fontSize:12.5,opacity:0.68,cursor:"pointer",transition:"opacity 0.15s"}}
                    onMouseEnter={e=>e.target.style.opacity="1"} onMouseLeave={e=>e.target.style.opacity="0.68"}>{l}</p>
                ))}
              </div>
            </div>
          ))}

          <div>
            <h4 className="footer-heading" style={{fontSize:16,letterSpacing:"0.3px",color:T.goldLight,margin:"0 0 16px"}}>Contact Us</h4>
            <div className="footer-contact-line" style={{fontSize:12.5,opacity:0.78,display:"flex",flexDirection:"column",gap:9,marginBottom:18}}>
              {contactLines.map(c=>(
                <div key={c.text} style={{display:"flex",alignItems:"flex-start",gap:9}}>
                  <IconBox icon={c.icon} box={16} size={13} bg="transparent" radius={0} style={{marginTop:2,flexShrink:0}}/>
                  <span>{c.text}</span>
                </div>
              ))}
            </div>
            <div className="footer-social-row" style={{display:"flex",gap:10,flexWrap:"wrap"}}>
              {social.map(s=>(
                <button key={s.name} className="footer-social-btn" aria-label={s.name} title={s.name}
                  style={{width:38,height:38,borderRadius:"50%",background:"rgba(255,255,255,0.08)",border:"1px solid rgba(255,255,255,0.16)",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",color:"#fff",transition:"all 0.2s",padding:0}}
                  onMouseEnter={e=>{e.currentTarget.style.background="rgba(255,255,255,0.18)";e.currentTarget.style.transform="translateY(-2px)";}}
                  onMouseLeave={e=>{e.currentTarget.style.background="rgba(255,255,255,0.08)";e.currentTarget.style.transform="none";}}>
                  <IconBox icon={s.icon} box={25} size={20} bg="transparent" radius={0}/>
                </button>
              ))}
            </div>
          </div>
        </div>
        <div className="footer-bottom-text" style={{borderTop:"1px solid rgba(255,255,255,0.08)",paddingTop:18,display:"flex",justifyContent:"space-between",fontSize:11.5,opacity:0.5,flexWrap:"wrap",gap:8}}>
          <span>© 2024 V-Solai Crop Solutions. All rights reserved.</span>
          <span>Privacy · Terms · Sitemap</span>
        </div>
      </div>
    </footer>
  );
}

/* ── APP ── */
export default function App() {
  const [page,setPage]=useState("home");
  const [cart,setCart]=useState([]);
  const [cartOpen,setCartOpen]=useState(false);

  useEffect(()=>{ window.scrollTo({top:0,behavior:"smooth"}); },[page]);

  // useLayoutEffect runs BEFORE the browser paints, so the CSS reset
  // (which zeroes the browser's default body margin) is applied before
  // anything is visible — this is what removes the gap above the header.
  useLayoutEffect(()=>{
    const s=document.createElement("style");
    s.textContent=GLOBAL_CSS;
    document.head.appendChild(s);
    return ()=>document.head.removeChild(s);
  },[]);

  const addToCart=p=>{
    setCart(prev=>{const ex=prev.find(i=>i.id===p.id);return ex?prev.map(i=>i.id===p.id?{...i,qty:i.qty+1}:i):[...prev,{...p,qty:1}];});
    setCartOpen(true);
  };
  const removeFromCart=id=>setCart(prev=>prev.filter(i=>i.id!==id));
  const changeQty=(id,d)=>setCart(prev=>prev.map(i=>i.id===id?{...i,qty:Math.max(1,i.qty+d)}:i));
  const cartCount=cart.reduce((s,i)=>s+i.qty,0);

  const pages={
    home:<HomePage setPage={setPage} onAdd={addToCart}/>,
    seeds:<ShopPage onAdd={addToCart} filterCat="seeds"/>,
    fertilizers:<ShopPage onAdd={addToCart} filterCat="fertilizers"/>,
    "crop-protection":<ShopPage onAdd={addToCart} filterCat="protection"/>,
    advisory:<AdvisoryPage/>,
    blog:<BlogPage/>,
    contact:<ContactPage/>,
  };

  return (
    <div style={{fontFamily:"'Inter','Segoe UI',system-ui,sans-serif",background:T.cream,minHeight:"100vh",color:T.charcoal,margin:0,padding:0}}>
      <NavBar page={page} setPage={p=>{setPage(p);}} cartCount={cartCount} setCartOpen={setCartOpen}/>
      <main style={{margin:0,padding:0}}>{pages[page]||pages.home}</main>
      <Footer setPage={setPage}/>

      {cartOpen&&(
        <>
          <div onClick={()=>setCartOpen(false)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.35)",zIndex:999,backdropFilter:"blur(2px)"}}/>
          <CartDrawer cart={cart} onClose={()=>setCartOpen(false)} onRemove={removeFromCart} onQty={changeQty}/>
        </>
      )}
    </div>
  );
}